export const SET_UNBOXING_PAGE = 'SET_UNBOXING_PAGE';
export const SET_ONBOARDING_FINISH_PAGE = 'SET_ONBOARDING_FINISH_PAGE';
export const SET_GLOWFORGE_NAMED = 'SET_GLOWFORGE_NAMED';
export const SET_GLOWFORGE_NAME_PAGE = 'SET_GLOWFORGE_NAME_PAGE';
export const SET_SELECT_PAGE = 'SET_SELECT_PAGE';
export const SET_INSTRUCTIONS_PAGE = 'SET_INSTRUCTIONS_PAGE';
export const SET_SELECTED_MODE = 'SET_SELECTED_MODE';
export const setSelectedMode = mode => ({
  type: SET_SELECTED_MODE,
  mode,
});



// WEBPACK FOOTER //
// ./app/actions/onboarding.js